module.exports = __webpack_public_path__ + "img/logo.1528eed2.png";